import { getLocalMonthYear, isSameDay, isSameMonth, isWeekend } from '@tesla/design-system';
import cx from 'classnames';
import React, { useEffect, useRef } from 'react';
export const Day = ({ between, className, date, end, error, first, focused, highlighted, isDisabled, last, month, onDateSelect, selected, start, ...rest }) => {
    const inThisMonth = isSameMonth(date, month);
    const disabled = typeof isDisabled === 'function' ? isDisabled(date) : isDisabled;
    const ref = useRef(null);
    useEffect(() => {
        if (focused && ref.current && inThisMonth && !disabled) {
            // TODO: There's a race-condition somewhere in the rendering logic that causes
            // about 1 in 50 re - renders to lose focus. This is a dirty hack to come back to
            // @ts-expect-error - see above
            setTimeout(() => ref.current.focus(), 25);
            // This would be the prefered approach:
            // ref.current.focus();
        }
    }, [disabled, focused, inThisMonth]);
    return (React.createElement("button", { "aria-label": !inThisMonth ? getLocalMonthYear(date) : undefined, "aria-selected": start || end, className: cx('tds-day', {
            'tds-day--error': error,
            'tds-day--selected': selected,
            'tds-day--between': between,
            'tds-day--first': first,
            'tds-day--last': last,
            'tds-day--start': start,
            'tds-day--end': end,
            'tds-day--highlighted': highlighted,
            'tds-day--today': isSameDay(date, new Date()),
            'tds-day--not-this-month': !inThisMonth,
            'tds-day--weekend': isWeekend(date),
        }, className), disabled: disabled, onClick: (e) => onDateSelect(e, date), ref: ref, tabIndex: inThisMonth ? undefined : -1, type: "button", ...rest },
        React.createElement("span", null, date.getDate())));
};
